import { Dimensions, Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const MAX_NOTIFICATION_WIDTH = widthPercentageToDP(340);
export const TABLET_RIGHT_INDENT = 36;

const styles = StyleSheet.create({
    root: {
        borderRadius: 4,
        flexDirection: 'row',
        paddingVertical: 16,
        paddingLeft: 24,
        paddingRight: 20,
        alignItems: 'center',
        position: 'absolute',
        zIndex: 999,
    },
    rootPhone: {
        maxWidth: MAX_NOTIFICATION_WIDTH,
        bottom: 20,
        left: (Dimensions.get('window').width - MAX_NOTIFICATION_WIDTH) / 2,
        justifyContent: 'flex-start',
        backgroundColor: COLOR.LIGHT_GREY,
        position: 'absolute',
    },
    rootPlayer: {
        top: isTabletOrWeb ? 72 : 16,
        right: widthPercentageToDP(10, 36, 72),
        maxWidth: MAX_NOTIFICATION_WIDTH,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        justifyContent: 'space-between',
        position: 'absolute',
    },
    rootTablet: {
        maxWidth: MAX_NOTIFICATION_WIDTH,
        top: heightPercentageToDP(72),
        right: Platform.select({
            web: widthPercentageToDP(72),
            default: TABLET_RIGHT_INDENT,
        }),
        justifyContent: 'space-between',
        backgroundColor: COLOR.LIGHT_GREY,
    },
    info: {
        flex: 1,
        marginLeft: 20,
    },
    body: {
        marginTop: 4,
    },
});

export default styles;
